export default __webpack_public_path__ + "static/media/pdfIcon.692377f7.svg";